import * as yup from 'yup'

export const validationSchema = yup.object({
  identificacao: yup.string().required('O campo é obrigatório.'),
  senha: yup.string().required('O campo é obrigatório.')
})
